import { CreditCard, Banknote } from "lucide-react";
import { PaymentSummary } from "../../types/cash/report";

interface Props {
  payments?: PaymentSummary[];
  title?: string;
}

/**
 * 💳 Sección de métodos de pago (sin card)
 */
const PaymentMethodsSection: React.FC<Props> = ({
  payments = [],
  title = "Métodos de pago",
}) => {

  const getIcon = (code: string) => {
    if (code === "01") return <Banknote size={16} />;
    return <CreditCard size={16} />;
  };

  const format = (value?: number) =>
    (value ?? 0).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });

  return (
    <div className="h-full flex flex-col">

      {/* 🔹 HEADER */}
      <div className="border-b border-stroke px-5 py-3 dark:border-strokedark">
        <h3 className="text-sm font-medium text-black dark:text-white">
          {title}
        </h3>
      </div>

      {/* 🔹 BODY */}
      <div className="p-5 flex-1">

        {payments.length ? (

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

            {payments.map((p) => (

              <div
                key={p.code}
                className="
                  flex items-center justify-between
                  rounded-sm border border-stroke
                  px-4 py-3
                  dark:border-strokedark
                  hover:bg-gray-50 dark:hover:bg-meta-4
                  transition
                "
              >

                {/* LEFT */}
                <div className="flex items-center gap-2 text-gray-500 dark:text-gray-400">
                  {getIcon(p.code)}
                  <span className="text-sm font-medium text-black dark:text-white">
                    {p.description}
                  </span>
                </div>

                {/* RIGHT */}
                <span className="text-sm font-semibold text-black dark:text-white">
                  {format(p.amount)}
                </span>

              </div>

            ))}

          </div>

        ) : (

          <div className="text-center text-gray-500 text-sm dark:text-gray-400 py-4">
            Sin ventas registradas
          </div>

        )}

      </div>

    </div>
  );
};

export default PaymentMethodsSection;